<div class="headline">
  <span class="mat-h1" style="margin: 0;">Profil</span>
</div>
<hr>

  @if (currentUser) {
    <div class="profile-content-wrapper">
      <div class="table-wrapper custom-scrollbar mat-elevation">
        <div class="table-header-wrapper">
          <h1 class="card-title m0">Kontodaten</h1>
          <div class="profile-button-wrapper">
            @if (authService.getUserRole() !== 'ROLE_ADMIN') {
              <button
                (click)="editProfile()"
                color="primary"
                mat-raised-button
                matTooltip="Profil bearbeiten"
                matTooltipShowDelay="1000"
                matTooltipPosition="above"
                matTooltipHideDelay="200"
                >
                <div class="center-content">
                  <mat-icon class="material-icon" fontIcon="edit"></mat-icon>
                </div>
              </button>
              <button
                (click)="deleteUser();"
                color="warn"
                mat-raised-button
                matTooltip="Account löschen"
                matTooltipShowDelay="1000"
                matTooltipPosition="above"
                matTooltipHideDelay="200"
                >
                <div class="center-content">
                  <mat-icon class="material-icon" fontIcon="delete"></mat-icon>
                </div>
              </button>
            }
          </div>
        </div>
        <table [dataSource]="tableData" mat-table style="margin-top: -2rem;">
          <ng-container matColumnDef="fields" style="margin-right: 1rem;">
            <th *matHeaderCellDef mat-header-cell id="account-information-table-header"></th>
            <td *matCellDef="let element" mat-cell class="table-font-size">{{element[0]}}</td>
          </ng-container>
          <ng-container matColumnDef="data">
            <th *matHeaderCellDef id="account-information-table-header-buttons" mat-header-cell>
            </th>
            <td *matCellDef="let element" class="table-font-size" mat-cell>
              @if (element[2] === 'settings') {
                <button (click)="openSettings()" class="table-font-size" mat-stroked-button>
                  <mat-icon>settings</mat-icon>
                  Einstellungen
                </button>
              } @else if (element[2] === 'password') {
                <button (click)="changePassword()" class="table-font-size" mat-stroked-button>
                  <mat-icon>lock_reset</mat-icon>
                  Passwort ändern
                </button>
              } @else {
                {{element[1] ? element[1] : ''}}
              }
            </td>
          </ng-container>
          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>
      </div>
    </div>
  }
